var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4992 10.2663L4.49872 10.2656L2.0892 7.08192L2.08904 7.0817C2.05422 7.03575 2.0288 6.98339 2.01424 6.92761L1.53046 7.05394L2.01424 6.92761C1.99967 6.87183 1.99624 6.81372 2.00414 6.75661C2.01204 6.69951 2.03113 6.64452 2.06029 6.59479C2.08946 6.54506 2.12815 6.50157 2.17413 6.4668L2.175 6.46615C2.22097 6.43123 2.27338 6.40573 2.32922 6.39111C2.38507 6.37649 2.44325 6.37303 2.50043 6.38094C2.55761 6.38884 2.61267 6.40796 2.66245 6.43718C2.71223 6.4664 2.75576 6.50517 2.79053 6.55124L2.79105 6.55193L4.37649 8.64517L4.81531 9.22453L5.1995 8.60759L9.18516 2.20733C9.18524 2.20721 9.18532 2.20708 9.1854 2.20696C9.2474 2.10806 9.34605 2.03774 9.45978 2.01139C9.57365 1.98501 9.69334 2.00488 9.79259 2.06662L9.79272 2.0667C9.99854 2.19467 10.062 2.46595 9.93327 2.67222L9.93311 2.67248L5.22332 10.2321L5.2228 10.233C5.18528 10.2935 5.13357 10.3439 5.07216 10.3799C5.01075 10.4158 4.94148 10.4363 4.87038 10.4394L4.85875 10.4399L4.855 10.4403L4.84925 10.4403C4.71166 10.4403 4.58207 10.3761 4.4992 10.2663Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckThin);
export default __webpack_public_path__ + "static/media/check_thin.6fa6351d69196786d15403561a441580.svg";
export { ForwardRef as ReactComponent };